module.exports = __webpack_public_path__ + "static/media/2.5c49918d.jpeg";